import { Stack } from '@mui/material';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { FormModal } from '../../../../components/modal/FormModal';
import { useModalToggle } from '../../../../components/modal/Modal';
import { PrimaryButton } from '../../../../components/style/ButtonStyle';
import { AddButtonIcon } from '../../../../layouts/dashboard/nav/IconButton';

export default function AddCategoryButton({
  label,
  form,
  onSubmit,
  children,
  postResult,
  getResult,
}: any) {
  const { on, open, close } = useModalToggle();
  const onCloseModal = () => {
    close();
    form.reset();
  };
  return (
    <Stack>
      <PrimaryButton onClick={open} startIcon={<AddButtonIcon />}>
        {label}
      </PrimaryButton>
      <FormModal
        on={on}
        onClose={onCloseModal}
        title={label}
        children={children}
        onConfirm={onSubmit}
      />
      <ApiResultModal
        apiResult={postResult}
        successTitle="등록됐습니다."
        successCode={201}
        onSuccessClose={() => {
          onCloseModal();
          getResult();
        }}
        failTitle="관리자에게 문의해주세요."
        ErrorCodeTable={{
          PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
          DUPLICATE_INSPECTION_RESULT: {
            title: '이미 존재하는 점검상태입니다.',
          },
          DUPLICATE_CATEGORY: { title: '이미 존재하는 유형입니다.' },
          DUPLICATE_SUB_CATEGORY: { title: '이미 존재하는 운동기구입니다.' },
          DUPLICATE_DEPARTMENT: { title: '이미 존재하는 부서입니다.' },
        }}
      />
    </Stack>
  );
}
